import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InitialsPipe } from './pipes/initials.pipe';
import { CountryNamePipe } from './pipes/country-name.pipe';
import { RequiredStringDirective } from './directives/required-string.directive';
import { MessagingModule } from './components/messaging/messaging.module';
import { DisplayShortNamePipe } from './pipes/display-short-name.pipe';
import { PreferredPricingIconModule } from './components/preferred-pricing-icon/preferred-pricing-icon.module';

@NgModule({
  declarations: [
    InitialsPipe,
    CountryNamePipe,
    DisplayShortNamePipe,
    RequiredStringDirective,
  ],
  exports: [
    InitialsPipe,
    CountryNamePipe,
    DisplayShortNamePipe,
    MessagingModule,
    RequiredStringDirective,
  ],
  imports: [
    CommonModule,
    MessagingModule,
    PreferredPricingIconModule,
  ]
})
export class SharedModule {
}
